import { Controller } from "react-hook-form";
import CustomerSelectField from "./CustomerSelectField";

const CustomerSelectFieldV2 = ({
  name = "",
  control,
  onChange = () => {},
  ...props
}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange: onControllerChange, value } }) => (
        <CustomerSelectField
          name={name}
          value={value}
          onControllerChange={onControllerChange}
          onChange={(id, customer) => {
            onChange(id, customer);
          }}
          {...props}
        />
      )}
    />
  );
};

export default CustomerSelectFieldV2;
